import React from 'react';
import { Link } from 'gatsby';
import ReCAPTCHA from 'react-google-recaptcha';

import { CloseSvg } from './svg';
import SocialIcons from './social-icons';

import Pantagruel from '../../../images/pantagruel-newsletter-360.png';

import '../../styles/common/exit-modal.scss';


// TODO: Make the form functionality here a component to be shared
// with subscription page
export default class ExitModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      nameError: false,
      emailError: false,
      captchaChallenge: false,
      shouldDisplay: false,
      readyToDisplay: false,
    }

    this.recaptchaRef = React.createRef();

    this.clearForm = this.clearForm.bind(this);
    this.displayCheck = this.displayCheck.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.onRecaptchaChange = this.onRecaptchaChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setCookie = this.setCookie.bind(this);
    this.validates = this.validates.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mouseout", (event) => {
      if (!event.toElement && !event.relatedTarget) {
        setTimeout(() => {
          this.displayCheck();
          this.setState({ readyToDisplay: true });
        }, 500)
      }
    });
  }

  clearForm() {
    this.recaptchaRef.current.reset();

    this.setState({
      nameError: false,
      emailError: false,
      captchaChallenge: false,
    });
  }

  displayCheck() {
    if (typeof(window) !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      const source = params.get("utm_source");
      
      if (source === 'newsletter') {
        this.setCookie();
        return;
      }
    }
    
    if (typeof(document) !== 'undefined') {
      if (document.cookie.split(';').filter(function(item) {
          return item.trim().indexOf('pdrExitNewsletter=') === 0
      }).length === 0) {
        this.setCookie();
        this.setState({ shouldDisplay: true });
      } else {
        this.setCookie();
      }
    }
  }

  handleDismiss() {
    this.setState({ shouldDisplay: false });
  }

  onRecaptchaChange(val) {
    this.setState({ captchaChallenge: true });
  }

  onSubmit(e) {
    // Validation
    if (!this.validates()) {
      e.preventDefault();
      return false;
    }

    // Captcha Challenge
    if (!this.state.captchaChallenge) {
      e.preventDefault();
      return false;
    }

    this.clearForm();
    this.setCookie();
    return true;
  }

  setCookie() {
    document.cookie = "pdrExitNewsletter=true;max-age=1814000"; // Expires in 21 days
  }

  validates() {
    let validates = true;

    if (this.state.name.length === 0) {
      validates = false;
      this.setState({ nameError: true });
    }

    if (this.state.email.length === 0) {
      validates = false;
      this.setState({ emailError: true });
    }

    return validates;
  }

  render() {
    return (
      <div
        className={`exit-modal__shade ${(this.state.readyToDisplay && this.state.shouldDisplay) ? 'expanded' : ''}`}
        onClick={ this.handleDismiss }
        aria-hidden={ true }
      >
        <button
          className="search-close-button"
          onClick={ this.handleDismiss }
        >
          { CloseSvg }
        </button>
        <div
          className="exit-modal__modal"
          onClick={ (e) => e.stopPropagation() }
          aria-hidden={ true }
        >
          <div className="exit-modal__grid">
            <div className="exit-modal__image">
              <img src={ Pantagruel } alt="Pantagruel" />
            </div>
            <div className="exit-modal__form">
              <div className="header">
                Sign Up for Our Newsletter!
              </div>
              <div className="subhead">
                The latest wonders from the site to your inbox.<br />
                Once every two weeks.
              </div>
              <form action="https://sendy.publicdomainreview.org/subscribe" method="POST" acceptCharset="utf-8"
                onSubmit={ this.onSubmit }
              >
                <input type="text" name="name" id="name" placeholder="Name"
                  className={this.state.nameError ? 'error' : ''}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
                <input type="email" name="email" id="email" placeholder="Email"
                  className={this.state.emailError ? 'error' : ''}
                  onChange={(e) => this.setState({ email: e.target.value })}
                />
                <div style={{ display: 'none' }}>
                  <label htmlFor="hp">HP</label>
                  <input type="text" name="hp" id="hp-modal-signup"/>
                </div>
                <input type="hidden" name="list" value="XkP00J8byzLyvtQqu763obgA"/>
                <input type="hidden" name="subform" value="yes"/>
                <div className="captcha-block">
                  <ReCAPTCHA
                    ref={ this.recaptchaRef }
                    sitekey="6LdjWMQUAAAAAFOrGEhy7Nsmu7TG4TSbRIRDteex"
                    onChange={ this.onRecaptchaChange }
                  />
                </div>
                <input type="submit" name="submit" id="submit" value="Subscribe" />
              </form>

              <div className="links">
                <Link to="/privacy-policy">Privacy Policy</Link> | <Link to="/subscribe">More Info</Link>
              </div>

              <div className="unsubscribe">
                You can unsubscribe at any time by clicking on the provided link in our emails.
              </div>
              <SocialIcons />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
